// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.-Landing-Screen {
  background-color: #fff;
}

.Finalyze-Copy {
  font-family: Poppins;
  font-size: 56px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #2c5ffe;
}

.The-data-for-investi {
  font-family: Poppins;
  font-size: 18px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #212121;
}

.Rectangle {
  margin: 0px 10px 14px 14px;
  padding: 6px 18px;
  border-radius: 17.5px;
  background-color: #f0f3ff;
  display: inline;
  float: left;
  cursor: pointer;
  text-transform: capitalize;

}

.text {
  font-family: Poppins;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #292929;
  text-transform: capitalize;
}

.Type-company-name-to {
  width: 283px;
  height: 26px;
  margin: 0 0 0 15.8px;
  font-family: Poppins;
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.44;
  letter-spacing: normal;
  color: #666;
}

.Type-brand-name-to-s {
display: inline;
  font-family: Poppins;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #8a8a8a;
  display: inline;
}

.nav-Links {
  margin: 0 30px 13px 0;
  font-family: Poppins;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
}

.company-Info {
  font-size: 32px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
}

.font-Style {
  font-family: Poppins;
  font-size: 14px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #0d0d0d;
  display: inline;
}

.font-numbers {
  font-family: RupeeForadian;
  font-size: 14px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #0d0d0d;
  display: inline;
}

.Line-Copy-12 {
  height: 3px;
  margin: 16px 0 0 0;
  border: solid 1px #ebf0ff;
  background-color: #ebf0ff;
}

.props-cons-Head {
  font-family: Poppins;
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #0d0d0d;
}

.props-cons-Text {
  font-family: Poppins;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: #525252;
}

.props-cons-sector-color {
  width: 12px;
  height: 12px;
  border-radius: 2px;
  margin-left: 20px;
}

.props-cons-Sector-text {
  margin: -2px 0 0 6px;
  font-family: Poppins;
  font-size: 12px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: #0d0d0d;
  text-transform: capitalize;
}
.Rectangle_props-cons {
  margin: 8px 8px 0 0;
  padding: 2px 6px;
  border-radius: 4px;
  background-color: #f7f7f7;
  text-align: center;
  justify-content: center ;
  cursor: pointer;
}
.Rectangle_props-cons-span {
  font-family: Poppins;
  font-size: 12px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: normal;
  text-align: center;
}
.-Year {
  margin: 0 1px 0 0;
  font-family: Poppins;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #525252;
}
.year-span{
  margin: 17px 0 0;
  font-family: Poppins;
  font-size: 12px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #0d0d0d;
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/landingPage.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,qBAAqB;EACrB,yBAAyB;EACzB,eAAe;EACf,WAAW;EACX,eAAe;EACf,0BAA0B;;AAE5B;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,WAAW;AACb;;AAEA;AACA,eAAe;EACb,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,0BAA0B;AAC5B;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,cAAc;AAChB","sourcesContent":[".-Landing-Screen {\r\n  background-color: #fff;\r\n}\r\n\r\n.Finalyze-Copy {\r\n  font-family: Poppins;\r\n  font-size: 56px;\r\n  font-weight: bold;\r\n  font-stretch: normal;\r\n  font-style: normal;\r\n  line-height: normal;\r\n  letter-spacing: normal;\r\n  color: #2c5ffe;\r\n}\r\n\r\n.The-data-for-investi {\r\n  font-family: Poppins;\r\n  font-size: 18px;\r\n  font-weight: 500;\r\n  font-stretch: normal;\r\n  font-style: normal;\r\n  line-height: normal;\r\n  letter-spacing: normal;\r\n  color: #212121;\r\n}\r\n\r\n.Rectangle {\r\n  margin: 0px 10px 14px 14px;\r\n  padding: 6px 18px;\r\n  border-radius: 17.5px;\r\n  background-color: #f0f3ff;\r\n  display: inline;\r\n  float: left;\r\n  cursor: pointer;\r\n  text-transform: capitalize;\r\n\r\n}\r\n\r\n.text {\r\n  font-family: Poppins;\r\n  font-size: 16px;\r\n  font-weight: normal;\r\n  font-stretch: normal;\r\n  font-style: normal;\r\n  line-height: normal;\r\n  letter-spacing: normal;\r\n  color: #292929;\r\n  text-transform: capitalize;\r\n}\r\n\r\n.Type-company-name-to {\r\n  width: 283px;\r\n  height: 26px;\r\n  margin: 0 0 0 15.8px;\r\n  font-family: Poppins;\r\n  font-size: 18px;\r\n  font-weight: normal;\r\n  font-stretch: normal;\r\n  font-style: normal;\r\n  line-height: 1.44;\r\n  letter-spacing: normal;\r\n  color: #666;\r\n}\r\n\r\n.Type-brand-name-to-s {\r\ndisplay: inline;\r\n  font-family: Poppins;\r\n  font-size: 14px;\r\n  font-weight: normal;\r\n  font-stretch: normal;\r\n  font-style: normal;\r\n  line-height: normal;\r\n  letter-spacing: normal;\r\n  color: #8a8a8a;\r\n  display: inline;\r\n}\r\n\r\n.nav-Links {\r\n  margin: 0 30px 13px 0;\r\n  font-family: Poppins;\r\n  font-size: 14px;\r\n  font-weight: bold;\r\n  font-stretch: normal;\r\n  font-style: normal;\r\n  line-height: normal;\r\n  letter-spacing: normal;\r\n}\r\n\r\n.company-Info {\r\n  font-size: 32px;\r\n  font-weight: 600;\r\n  font-stretch: normal;\r\n  font-style: normal;\r\n  line-height: normal;\r\n  letter-spacing: normal;\r\n}\r\n\r\n.font-Style {\r\n  font-family: Poppins;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  font-stretch: normal;\r\n  font-style: normal;\r\n  line-height: normal;\r\n  letter-spacing: normal;\r\n  color: #0d0d0d;\r\n  display: inline;\r\n}\r\n\r\n.font-numbers {\r\n  font-family: RupeeForadian;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  font-stretch: normal;\r\n  font-style: normal;\r\n  line-height: normal;\r\n  letter-spacing: normal;\r\n  color: #0d0d0d;\r\n  display: inline;\r\n}\r\n\r\n.Line-Copy-12 {\r\n  height: 3px;\r\n  margin: 16px 0 0 0;\r\n  border: solid 1px #ebf0ff;\r\n  background-color: #ebf0ff;\r\n}\r\n\r\n.props-cons-Head {\r\n  font-family: Poppins;\r\n  font-size: 16px;\r\n  font-weight: 600;\r\n  font-stretch: normal;\r\n  font-style: normal;\r\n  line-height: normal;\r\n  letter-spacing: normal;\r\n  color: #0d0d0d;\r\n}\r\n\r\n.props-cons-Text {\r\n  font-family: Poppins;\r\n  font-size: 12px;\r\n  font-weight: normal;\r\n  font-stretch: normal;\r\n  font-style: normal;\r\n  line-height: 1.5;\r\n  letter-spacing: normal;\r\n  color: #525252;\r\n}\r\n\r\n.props-cons-sector-color {\r\n  width: 12px;\r\n  height: 12px;\r\n  border-radius: 2px;\r\n  margin-left: 20px;\r\n}\r\n\r\n.props-cons-Sector-text {\r\n  margin: -2px 0 0 6px;\r\n  font-family: Poppins;\r\n  font-size: 12px;\r\n  font-weight: 500;\r\n  font-stretch: normal;\r\n  font-style: normal;\r\n  line-height: 1.5;\r\n  letter-spacing: normal;\r\n  color: #0d0d0d;\r\n  text-transform: capitalize;\r\n}\r\n.Rectangle_props-cons {\r\n  margin: 8px 8px 0 0;\r\n  padding: 2px 6px;\r\n  border-radius: 4px;\r\n  background-color: #f7f7f7;\r\n  text-align: center;\r\n  justify-content: center ;\r\n  cursor: pointer;\r\n}\r\n.Rectangle_props-cons-span {\r\n  font-family: Poppins;\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  font-stretch: normal;\r\n  font-style: normal;\r\n  line-height: 1.33;\r\n  letter-spacing: normal;\r\n  text-align: center;\r\n}\r\n.-Year {\r\n  margin: 0 1px 0 0;\r\n  font-family: Poppins;\r\n  font-size: 12px;\r\n  font-weight: normal;\r\n  font-stretch: normal;\r\n  font-style: normal;\r\n  line-height: normal;\r\n  letter-spacing: normal;\r\n  color: #525252;\r\n}\r\n.year-span{\r\n  margin: 17px 0 0;\r\n  font-family: Poppins;\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  font-stretch: normal;\r\n  font-style: normal;\r\n  line-height: normal;\r\n  letter-spacing: normal;\r\n  color: #0d0d0d;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
